import type { Dispatch, SetStateAction } from 'react';

import { Box, DialogActions, Typography } from '@/shared/ui';

import { spacing } from '@/config/ui';
import { Dialog, DialogButton } from '@/shared/ui/overlays/Modal';
import { LockingDisableButton } from '@/shared/ui/overlays/Modal/LockingDisableButton';

const ConfirmDialog = ({
  open,
  setOpen,
  deleteCallback
}: {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  deleteCallback: () => void;
}) => {
  return (
    <Dialog
      open={open}
      title='Remove API token?'
      onClose={() => {
        setOpen(false);
      }}
    >
      <>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Typography sx={{ mr: 3 }}>
            This action cannot be undone, and any applications using this token will lose access.
          </Typography>
        </Box>

        <DialogActions sx={{ mt: spacing[2], gap: spacing[1] }}>
          <DialogButton
            variant='outlined'
            onClick={() => {
              setOpen(false);
            }}
          >
            Cancel
          </DialogButton>
          <LockingDisableButton
            clickCallback={() => {
              deleteCallback();
            }}
            variant='contained'
          >
            Delete token
          </LockingDisableButton>
        </DialogActions>
      </>
    </Dialog>
  );
};
export default ConfirmDialog;
